import { UISDK } from "@/ui-sdk";
import { flagCheck } from "..";
import { getLowTicketSizeRecommendationFromHandles } from "./utils/get-low-ticket-size-recommendations";

export default async function handleLowTicketRecommendation(
  element: HTMLElement,
  sdk: UISDK,
) {
  if (!flagCheck("low-ticket-size-recommendation")) return;

  await new Promise((resolve) => setTimeout(resolve, 1_000));
  const handle = window.location.pathname.split("/").at(-1) as string;
  return getLowTicketSizeRecommendationFromHandles([handle])
    .then(async (e) => {
      const products = getProductsFromRecommendations(e);

      await window.fetchAndEmbedListings(products, true);

      return e;
    })
    .then((e) => {
      return sdk.renderLowTicketRecommendation(
        {
          c: e,
          s: [],
          key: Date.now().toString(),
          loading: false,
          currentProductHandle: "geometrical-design-cotton-bedcover-31",
        },
        element,
      );
    });
}

function getProductsFromRecommendations(
  e: Record<string, Record<string, { handle: string }[]>>,
) {
  const values = Object.values(e);

  const products: { handle: string }[] = [];

  values.forEach((value) => {
    Object.values(value)
      .flat()
      .forEach((product) => {
        console.info({ product });
        products.push(product);
      });
  });

  return Array.from(new Set(products));
}
